export default {
  en: {
    treasury: {
      title: 'Treasury',
      operations: 'Operations',
      create: 'New operation',
      createTitle: 'Create treasury operation',
      completeTitle: 'Complete operation',
      type: 'Type',
      provider: 'Exchange',
      btcAmount: 'BTC amount',
      usdtAmount: 'USDT amount',
      rubAmount: 'RUB amount',
      txId: 'Transaction ID',
      notes: 'Notes',
      statusPLANNED: 'Planned',
      statusEXECUTING: 'Executing',
      statusCOMPLETED: 'Completed',
      statusFAILED: 'Failed',
      statusCANCELLED: 'Cancelled',
      start: 'Start',
      complete: 'Complete',
      fail: 'Failed',
      cancel: 'Cancel',
      confirmFail: 'Mark this operation as failed? This cannot be undone.',
      confirmCancel: 'Cancel this operation? This cannot be undone.',
      corporateWallet: 'Corporate wallet (FNS)',
      corporateWalletRequired: 'Select a FNS-certified corporate wallet for WITHDRAW_CRYPTO',
      exportCsv: 'Export CSV'
    },
    fnsWallets: {
      title: 'FNS Wallets (VED / IMEX)',
      address: 'Address',
      network: 'Network',
      coin: 'Coin',
      certified: 'FNS certified'
    },
    corporateWallet: {
      title: 'RUSBIT Corporate Wallets',
      wallets: 'FNS-registered wallets',
      add: 'Add wallet',
      addTitle: 'New corporate wallet',
      address: 'Address',
      network: 'Network',
      coin: 'Coin',
      notes: 'Notes',
      fnsCertified: 'FNS certified',
      fnsRegisteredAt: 'FNS registration date',
      confirmDelete: 'Delete this wallet? This cannot be undone.'
    },
    rubWithdrawal: {
      title: 'RUB Withdrawals',
      queue: 'Withdrawal Queue',
      statusPENDING: 'Pending',
      statusPROCESSING: 'Processing',
      statusCOMPLETED: 'Completed',
      statusFAILED: 'Rejected',
      toProcessing: 'Accept',
      complete: 'Complete',
      reject: 'Reject',
      rejectTitle: 'Reject withdrawal',
      adminNote: 'Admin note (reason)',
      bank: 'Bank details',
      rate: 'Rate ₽/BTC'
    },
    route: {
      home: 'Home',
      login: 'Login',
      users: 'Users',
      report: 'Reports',
      miners: 'Miners',
      devices: 'Devices',
      pools: 'Pools',
      rank: 'Rank',
      telegram: 'Telegram',
      settings: 'Settings',
      payouts: 'Payouts',
      wallet: 'Wallet',
      registration: 'Registration',
      finance: 'Finance',
      email: 'Email',
      transaction: 'Transactions',
      subusers: 'Subusers',
      coreproxy: 'Coreproxy',
      agents: 'Agents',
      referrals: 'Referrals',
      'rub-withdrawal': 'RUB Withdrawals',
      treasury: 'Treasury',
      corporateWallets: 'Corporate Wallets'
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      name: 'Name',
      email: 'Email',
      status: 'Status',
      action: 'Action',
      created: 'Created',
      updated: 'Updated',
      list: 'List',
      id: 'ID',
      code: 'Code',
      submit: 'Submit',
      min: 'min',
      max: 'max',
      control: 'Control',
      date: 'Date',
      login: 'Login',
      hashrate: 'Hashrate',
      tags: 'Tags',
      refresh: 'Refresh',
      apply: 'Apply',
      on: 'ON',
      off: 'OFF',
      all: 'ALL',
      pay: 'Pay',
      payAll: 'Pay All',
      ok: 'OK',
      enable: 'Enable',
      loading: 'Loading...',
      active: 'Active',
      disabled: 'Disabled',
      loadingWait: 'Loading... Please wait',
      userId: 'User ID',
      deleted: 'Deleted',
      filter: 'Filter',
      yes: 'Yes',
      no: 'No'
    },
    settings: {
      title: 'Settings',
      main: 'Main',
      userName: 'User name',
      language: 'Language',
      timeZone: 'Time Zone',
      security: 'Security',
      verifyCode: 'Verify code',
      getVerifyCode: 'Get verify code',
      enable2fa: 'Enable 2FA',
      notification: 'Notification',
      newPassword: 'New Password',
      verifyPassword: 'Verify Password',
      autoWithdrawal: 'Auto withdrawal',
      enableAutoWithdrawal: 'Enable auto withdrawal',
      minimalWithdrawal: 'Minimal withdrawal',
      withdrawalScheduler: 'Withdrawal scheduler',
      mainWallet: 'Main wallet',
      hashrate: 'Hashrate',
      income: 'Income',
      shutdown: 'Shutdown',
      newDevice: 'New Device'
    },
    subusers: {
      title: 'Subusers',
      list: 'Subuser list',
      addSubuser: 'Add subuser',
      miners: 'Miners',
      feeIncome: 'Fee income, %',
      feeBonus: 'Fee bonus, %',
      incomeFee: 'Income Fee, %',
      bonusFee: 'Bonus Fee, %',
      allMiners: 'All Miners:',
      selectedMiners: 'Selected Miners:',
      incomeTitle: 'Income {email} subuser',
      deleteTitle: 'Delete subuser',
      deleteText: 'Delete subuser {email}? This cannot be undone.'
    },
    referrals: {
      agent: 'Agent',
      title: 'Referrals',
      agentStatus: 'Agent status:',
      inviteCode: 'Invite code:',
      permissionIncome: 'Permission income:',
      permissionBonus: 'Permission bonus:',
      permissionReferral: 'Permission referral:',
      dayHashrate: 'Day Hashrate:',
      feeIncome: 'Fee income',
      feeBonus: 'Fee bonus',
      refToUser: 'Ref to user:',
      reward: 'Reward'
    },
    wallet: {
      title: 'Wallet',
      available: 'Available',
      allTimeIncome: 'All time income:',
      inProcessing: 'In processing:',
      allPaid: 'All paid:',
      expected: 'Expected',
      transactions: 'Transactions',
      convert: 'Convert',
      wallets: 'Wallets',
      walletName: 'Wallet name',
      assets: 'Assets',
      network: 'Network',
      address: 'Address',
      addressTag: 'Address tag',
      main: 'Main',
      deposit: 'Deposit',
      url: 'URL',
      withdrawTitle: 'Withdraw your BTC to wallet',
      amount: 'Amount',
      toWallet: 'To wallet',
      tag: 'Tag',
      withdraw: 'Withdraw',
      headersDate: 'Date',
      headersStatus: 'Status',
      headersType: 'Type',
      headersAmount: 'Amount',
      headersCurrency: 'Currency',
      headersAddress: 'Address',
      headersInfo: 'Info',
      price: 'Price:',
      convertYour: 'Convert your {from}',
      youGet: 'You get {to}',
      unavailable: 'Wallet unavailable',
      loadingWallet: 'Loading wallet...'
    },
    pools: {
      title: 'Pools',
      account: 'Account',
      default: 'Default',
      refBonus: 'Ref bonus',
      mainFee: 'Our main fee, %',
      refFee: 'Our ref fee, %',
      stratum: 'Stratum',
      incomePools: 'Pools income: Pools',
      incomeOwners: 'Pools income: Owners',
      incomeAccounts: 'Pools income: Accounts',
      additionalMainFee: 'Additional main fee, %',
      additionalRefFee: 'Additional referral fee, %',
      switchAll: 'Switch all',
      clearRecalc: 'Clear and recalc',
      recalc10d: 'Recalc last 10d',
      editTitle: 'Edit pool',
      useRandomMain: 'Use random main fee',
      useRandomRef: 'Use random referral fee',
      refProgram: 'Pool referral program, %',
      host: 'Host',
      port: 'Port',
      mainStratum: 'Main Stratum',
      reserveStratum: 'Reserve Stratum',
      host2: 'Host 2',
      port2: 'Port 2',
      fnsAddress: 'Mining pool identifier address',
      exchangeProvider: 'Exchange',
      exchangeProviderWarning: 'Changes payout routing for this pool immediately on save — no restart. KuCoin adapter is not yet verified for production traffic.'
    },
    miners: {
      newPoolId: 'New pool ID',
      enterPoolId: 'Enter pool id',
      worker: 'Worker',
      user: 'User',
      poolId: 'Pool ID',
      pool: 'Pool',
      info: 'Info',
      inetAddress: 'Inet Address',
      action: 'Action',
      setNominal: 'Set nominal',
      calcHashrate: 'Calc Hashrate',
      calcIncome: 'Calc Income',
      noWorkers: 'No workers found',
      lastIp: 'Last IP:'
    },
    agents: {
      title: 'Agents',
      adminAgent: 'Admin agent',
      allReferrals: 'All user referrals',
      totalReferrals: 'Total referrals',
      totalHashrate: 'Total last day hashrate',
      rank: 'Rank'
    },
    telegram: {
      users: 'Telegram Users',
      watchers: 'Watchers',
      badWatchers: 'Bad Watchers',
      firstName: 'First name',
      lastName: 'Last name',
      username: 'Username',
      lang: 'Language',
      bot: 'Bot',
      mailing: 'Mailing',
      mailingPeriod: 'Mailing period',
      link: 'Link',
      tUserId: 'Telegram User ID',
      error: 'Error'
    },
    transactions: {
      title: 'Transactions',
      exchangeFee: 'Exchange Fee',
      userStats: 'Users Operations Statistic',
      deposit: 'Deposit',
      exchange: 'Exchange',
      withdraw: 'Withdraw',
      rejectReason: 'Reject reason',
      convertFee: 'Convert fee, %',
      showDetails: 'show details',
      hideDetails: 'hide details',
      rejectTitle: 'Reject transaction',
      reject: 'Reject',
      fromUsdt: 'FROM USDT',
      fromBtc: 'FROM BTC'
    },
    finance: {
      title: 'Finance',
      income: 'Income',
      bonus: 'Bonus',
      agent: 'Agent',
      amount: 'Amount, BTC',
      total: 'Total',
      users: 'Users',
      our: 'Our (admin)',
      expect: 'Expect:',
      paid: 'Paid:',
      emcdBalance: 'EMCD Balance',
      payAllIncome: 'Pay ALL Income',
      payAllBonus: 'Pay ALL Bonus',
      payAllAgentBonus: 'Pay ALL Agent Bonus',
      confirmPayTitle: 'Confirm payout',
      confirmPayText: 'Run "{action}"? This cannot be undone.',
      payError: 'Payout failed',
      transferToRef: 'Transfer to ref',
      pool: 'Pool',
      referral: 'Referral',
      agentBonus: 'Agent Bonus',
      recalc: 'Recalc',
      fixBonusPayout: 'Fix bonus payout'
    },
    coreProxy: {
      title: 'Core Proxy',
      flushCache: 'Flush Cache',
      terminateAll: 'Terminate All Connections'
    },
    nav: {
      setupDevice: 'Setup Device'
    },
    email: {
      sendEmail: 'Send email',
      verifying: 'Verifying...',
      to: 'To',
      subject: 'Subject',
      text: 'Text',
      send: 'Send',
      sent: 'Email sent successfully'
    },
    poolStat: {
      hashPool: 'Hash pool',
      hashBalancer: 'Hash balancer',
      rewardPool: 'Reward pool',
      paid: 'Paid',
      refCalc: 'Ref calc',
      refPaid: 'Ref paid',
      ratePool: 'Rate pool'
    },
    userWatcher: {
      list: 'List',
      workers: 'Workers',
      transaction: 'Transaction',
      newWatcher: 'New watcher:',
      watcherTitle: 'Watcher Links'
    },
    userStat: {
      emcd: 'EMCD',
      total: 'Total'
    },
    incomeSub: {
      hash: 'Hash',
      income: 'Income',
      incomeFee: 'Income Fee',
      referral: 'Referral',
      referralFee: 'Referral Fee',
      forPay: 'For Pay',
      profit: 'Profit'
    },
    home: {
      title: 'Dashboard',
      users: 'Users',
      activeUsers: 'Active Users',
      onlyRegist: 'Registered Only',
      deadUsers: 'Inactive Users',
      activeMiners: 'Active Miners',
      incomeBTC: 'Income, BTC',
      allBalance: 'Total Balance',
      bonusBTC: 'Bonus, BTC',
      bonusPercent: 'Bonus, %',
      noData: 'No data available',
      prev: 'PREV',
      next: 'NEXT',
      tksAccount: 'Account',
      tksType: 'Type',
      tksUnavailable: 'Unavailable (riskBinary unreachable or not configured)',
      tksCurrencyBalanceTitle: 'IMEX TKS Balance by currency',
      tksCurrencyBalanceNote: 'Joins riskBinary Pos.PositionUpdate (balance_id) with the Instruments/Currency dictionary. Verified against a live server response on 2026-09-02 (RUSBT001/002 returned RUB and IMEX — the exchange\'s own token, not USDT).',
      tksCurrencyCode: 'Currency',
      tksCurrencyBalanceId: 'balance_id',
      tksCurrencyAmount: 'Amount (clear_amount)',
      tksCurrencyUnknown: 'unknown (not in dictionary)'
    },
    users: {
      role: 'Role',
      vipMain: 'VIP main bonus',
      vipRef: 'VIP ref bonus',
      blocked: 'Blocked',
      editTitle: 'Edit user',
      createTitle: 'Create user',
      addUser: 'Add user',
      emailVerified: 'Email verified',
      wallet: 'Wallet',
      phone: 'Phone',
      minerPass: 'Miner pass',
      switchPool: 'Switch user to pool:',
      switchBtn: 'Switch',
      clearRecalc: 'Clear and recalc',
      recalc10d: 'Recalc 10d'
    },
    auth: {
      title: 'Login',
      password: 'Password',
      minChars: 'At least 3 characters',
      error: 'Authentication error',
      errorEmailNotVerified: 'Email not verified. Please confirm your email to log in.',
      goToVerify: 'Verify email',
      restore: 'Restore',
      restoreTitle: 'Restore password',
      confirmEmail: 'Confirm email',
      resendCode: 'Resend code',
      signIn: 'Sign in',
      required: 'Required field!',
      repeatPassword: 'Repeat password',
      min4: 'At least 4 characters',
      min8: 'At least 8 characters',
      passwordMismatch: 'Passwords do not match',
      invalidEmail: 'Invalid email'
    },
    report: {
      title: 'Reports',
      reportFor: 'Report for'
    },
    hashrate: {
      '10min': '10 min hashrate',
      '1hour': '1 hour hashrate',
      '24hour': '24 hour hashrate',
      shares: 'Shares:',
      legend: '(accept / reject (%) / total)'
    },
    setupMiner: {
      title: 'Setup your stratum configuration',
      workerConfig: 'Worker configuration',
      workerHint: 'You need to identify and get per machine statistics by setting unique worker names for each of your rigs.',
      passwordHint: 'If you set a password for miners in settings, you must specify this password in the miner configuration.'
    },
    minerCard: {
      number: 'Number:',
      active: 'Active:',
      model: 'Model:',
      owner: 'Owner:'
    },
    minerStatus: {
      info: 'Information',
      model: 'Model:',
      algorithm: 'Algorithm:',
      website: 'Website:'
    },
    pivot: {
      avgHash: 'Avg hashrate per day, Th/s',
      power: 'Power consumption, kW',
      powerCost: 'Power cost, RUB',
      poolPayout: 'Pool payout, BTC',
      service: 'Service fee {service} BTC ({percent}%). Net profit {profit} BTC',
      total: 'Total:'
    }
  },
  ru: {
    treasury: {
      title: 'Казначейство',
      operations: 'Операции',
      create: 'Новая операция',
      createTitle: 'Создать казначейскую операцию',
      completeTitle: 'Завершить операцию',
      type: 'Тип',
      provider: 'Биржа',
      btcAmount: 'Сумма BTC',
      usdtAmount: 'Сумма USDT',
      rubAmount: 'Сумма ₽',
      txId: 'ID транзакции',
      notes: 'Примечание',
      statusPLANNED: 'Запланировано',
      statusEXECUTING: 'Выполняется',
      statusCOMPLETED: 'Выполнено',
      statusFAILED: 'Ошибка',
      statusCANCELLED: 'Отменено',
      start: 'Начать',
      complete: 'Завершить',
      fail: 'Ошибка',
      cancel: 'Отменить',
      confirmFail: 'Пометить операцию как ошибочную? Действие необратимо.',
      confirmCancel: 'Отменить операцию? Действие необратимо.',
      corporateWallet: 'Корпоративный кошелёк (ФНС)',
      corporateWalletRequired: 'Выберите ФНС-сертифицированный корпоративный кошелёк для WITHDRAW_CRYPTO',
      exportCsv: 'Выгрузить CSV'
    },
    fnsWallets: {
      title: 'ФНС-кошельки (ВЭД / IMEX)',
      address: 'Адрес',
      network: 'Сеть',
      coin: 'Монета',
      certified: 'ФНС сертифицирован'
    },
    corporateWallet: {
      title: 'Корпоративные кошельки РУСБИТ',
      wallets: 'Кошельки, зарегистрированные в ФНС',
      add: 'Добавить кошелёк',
      addTitle: 'Новый корпоративный кошелёк',
      address: 'Адрес',
      network: 'Сеть',
      coin: 'Монета',
      notes: 'Заметки',
      fnsCertified: 'ФНС сертифицирован',
      fnsRegisteredAt: 'Дата регистрации в ФНС',
      confirmDelete: 'Удалить этот кошелёк? Действие нельзя отменить.'
    },
    rubWithdrawal: {
      title: 'Выводы в рублях',
      queue: 'Очередь заявок',
      statusPENDING: 'Ожидает',
      statusPROCESSING: 'В обработке',
      statusCOMPLETED: 'Исполнено',
      statusFAILED: 'Отклонено',
      toProcessing: 'В работу',
      complete: 'Исполнено',
      reject: 'Отклонить',
      rejectTitle: 'Отклонить заявку',
      adminNote: 'Причина отклонения',
      bank: 'Реквизиты',
      rate: 'Курс ₽/BTC'
    },
    route: {
      home: 'Главная',
      login: 'Вход',
      users: 'Пользователи',
      report: 'Отчеты',
      miners: 'Устройства',
      devices: 'Устройства',
      pools: 'Пулы',
      rank: 'Рейтинг',
      telegram: 'Телеграм',
      settings: 'Настройки',
      payouts: 'Выплаты',
      wallet: 'Кошелек',
      registration: 'Регистрация',
      finance: 'Финансы',
      email: 'Почта',
      transaction: 'Сделки',
      subusers: 'Пользователи',
      coreproxy: 'Ядро',
      agents: 'Агенты',
      referrals: 'Рефералы',
      'rub-withdrawal': 'Выводы в ₽',
      treasury: 'Казначейство',
      corporateWallets: 'Корп. кошельки'
    },
    common: {
      save: 'Сохранить',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      add: 'Добавить',
      edit: 'Редактировать',
      delete: 'Удалить',
      close: 'Закрыть',
      name: 'Имя',
      email: 'Email',
      status: 'Статус',
      action: 'Действие',
      created: 'Создан',
      updated: 'Обновлён',
      list: 'Список',
      id: 'ID',
      code: 'Код',
      submit: 'Подтвердить',
      min: 'мин',
      max: 'макс',
      control: 'Управление',
      date: 'Дата',
      login: 'Логин',
      hashrate: 'Хешрейт',
      tags: 'Теги',
      refresh: 'Обновить',
      apply: 'Применить',
      on: 'ВКЛ',
      off: 'ВЫКЛ',
      all: 'ВСЕ',
      pay: 'Оплатить',
      payAll: 'Оплатить всё',
      ok: 'ОК',
      enable: 'Включить',
      loading: 'Загрузка...',
      active: 'Активный',
      disabled: 'Отключён',
      loadingWait: 'Загрузка... Подождите',
      userId: 'ID пользователя',
      deleted: 'Удалённые',
      filter: 'Фильтр',
      yes: 'Да',
      no: 'Нет'
    },
    settings: {
      title: 'Настройки',
      main: 'Основное',
      userName: 'Имя пользователя',
      language: 'Язык',
      timeZone: 'Часовой пояс',
      security: 'Безопасность',
      verifyCode: 'Код подтверждения',
      getVerifyCode: 'Получить код',
      enable2fa: 'Включить 2FA',
      notification: 'Уведомление',
      newPassword: 'Новый пароль',
      verifyPassword: 'Подтверждение пароля',
      autoWithdrawal: 'Авто-вывод',
      enableAutoWithdrawal: 'Включить авто-вывод',
      minimalWithdrawal: 'Минимальная сумма вывода',
      withdrawalScheduler: 'Расписание вывода',
      mainWallet: 'Основной кошелёк',
      hashrate: 'Хешрейт',
      income: 'Доход',
      shutdown: 'Отключение',
      newDevice: 'Новое устройство'
    },
    subusers: {
      title: 'Субпользователи',
      list: 'Список субпользователей',
      addSubuser: 'Добавить субпользователя',
      miners: 'Устройства',
      feeIncome: 'Комиссия дохода, %',
      feeBonus: 'Комиссия бонуса, %',
      incomeFee: 'Комиссия дохода, %',
      bonusFee: 'Комиссия бонуса, %',
      allMiners: 'Все устройства:',
      selectedMiners: 'Выбранные устройства:',
      incomeTitle: 'Доход субпользователя {email}',
      deleteTitle: 'Удаление субпользователя',
      deleteText: 'Удалить субпользователя {email}? Действие необратимо.'
    },
    referrals: {
      agent: 'Агент',
      title: 'Рефералы',
      agentStatus: 'Статус агента:',
      inviteCode: 'Реф. код:',
      permissionIncome: 'Разрешение доход:',
      permissionBonus: 'Разрешение бонус:',
      permissionReferral: 'Разрешение реферал:',
      dayHashrate: 'Дневной хешрейт:',
      feeIncome: 'Комиссия дохода',
      feeBonus: 'Комиссия бонуса',
      refToUser: 'Реферальный %:',
      reward: 'Вознаграждение'
    },
    wallet: {
      title: 'Кошелёк',
      available: 'Доступно',
      allTimeIncome: 'Общий доход:',
      inProcessing: 'В обработке:',
      allPaid: 'Всего выплачено:',
      expected: 'Ожидается',
      transactions: 'Транзакции',
      convert: 'Конвертировать',
      wallets: 'Кошельки',
      walletName: 'Название кошелька',
      assets: 'Активы',
      network: 'Сеть',
      address: 'Адрес',
      addressTag: 'Тег адреса',
      main: 'Основной',
      deposit: 'Пополнение',
      url: 'URL',
      withdrawTitle: 'Вывод BTC на кошелёк',
      amount: 'Сумма',
      toWallet: 'На кошелёк',
      tag: 'Тег',
      withdraw: 'Вывести',
      headersDate: 'Дата',
      headersStatus: 'Статус',
      headersType: 'Тип',
      headersAmount: 'Сумма',
      headersCurrency: 'Валюта',
      headersAddress: 'Адрес',
      headersInfo: 'Инфо',
      price: 'Цена:',
      convertYour: 'Конвертировать {from}',
      youGet: 'Вы получите {to}',
      unavailable: 'Кошелёк недоступен',
      loadingWallet: 'Загрузка кошелька...'
    },
    pools: {
      title: 'Пулы',
      account: 'Аккаунт',
      default: 'По умолчанию',
      refBonus: 'Реф. бонус',
      mainFee: 'Осн. комиссия, %',
      refFee: 'Реф. комиссия, %',
      stratum: 'Стратум',
      incomePools: 'Доход пулов: Пулы',
      incomeOwners: 'Доход пулов: Владельцы',
      incomeAccounts: 'Доход пулов: Аккаунты',
      additionalMainFee: 'Доп. осн. комиссия, %',
      additionalRefFee: 'Доп. реф. комиссия, %',
      switchAll: 'Переключить всех',
      clearRecalc: 'Очистить и пересчитать',
      recalc10d: 'Пересчитать за 10 дней',
      editTitle: 'Редактировать пул',
      useRandomMain: 'Случайная осн. комиссия',
      useRandomRef: 'Случайная реф. комиссия',
      refProgram: 'Реф. программа пула, %',
      host: 'Хост',
      port: 'Порт',
      mainStratum: 'Главный стратум',
      reserveStratum: 'Резервный стратум',
      exchangeProvider: 'Биржа',
      exchangeProviderWarning: 'Меняет маршрутизацию выплат этого пула сразу при сохранении — без рестарта. Адаптер KuCoin ещё не проверен для боевого трафика.',
      host2: 'Хост 2',
      port2: 'Порт 2',
      fnsAddress: 'Адрес-идентификатор майнинг-пула'
    },
    miners: {
      newPoolId: 'Новый ID пула',
      enterPoolId: 'Введите ID пула',
      worker: 'Воркер',
      user: 'Пользователь',
      poolId: 'ID пула',
      pool: 'Пул',
      info: 'Инфо',
      inetAddress: 'IP-адрес',
      action: 'Действие',
      setNominal: 'Задать номинал',
      calcHashrate: 'Рассчитать хешрейт',
      calcIncome: 'Рассчитать доход',
      noWorkers: 'Воркеры не найдены',
      lastIp: 'Последний IP:'
    },
    agents: {
      title: 'Агенты',
      adminAgent: 'Агент-администратор',
      allReferrals: 'Все рефералы пользователей',
      totalReferrals: 'Всего рефералов',
      totalHashrate: 'Хешрейт за последний день',
      rank: 'Ранг'
    },
    telegram: {
      users: 'Пользователи Telegram',
      watchers: 'Наблюдатели',
      badWatchers: 'Проблемные наблюдатели',
      firstName: 'Имя',
      lastName: 'Фамилия',
      username: 'Имя пользователя',
      lang: 'Язык',
      bot: 'Бот',
      mailing: 'Рассылка',
      mailingPeriod: 'Частота рассылки',
      link: 'Ссылка',
      tUserId: 'ID Telegram пользователя',
      error: 'Ошибка'
    },
    transactions: {
      title: 'Транзакции',
      exchangeFee: 'Комиссия обмена',
      userStats: 'Статистика операций пользователей',
      deposit: 'Депозит',
      exchange: 'Обмен',
      withdraw: 'Вывод',
      rejectReason: 'Причина отклонения',
      convertFee: 'Комиссия конвертации, %',
      showDetails: 'показать детали',
      hideDetails: 'скрыть детали',
      rejectTitle: 'Отклонить транзакцию',
      reject: 'Отклонить',
      fromUsdt: 'ИЗ USDT',
      fromBtc: 'ИЗ BTC'
    },
    finance: {
      title: 'Финансы',
      income: 'Доход',
      bonus: 'Бонус',
      agent: 'Агент',
      amount: 'Сумма, BTC',
      total: 'Итого',
      users: 'Пользователи',
      our: 'Наши (admin)',
      expect: 'Ожидается:',
      paid: 'Выплачено:',
      emcdBalance: 'EMCD Баланс',
      payAllIncome: 'Выплатить весь доход',
      payAllBonus: 'Выплатить все бонусы',
      payAllAgentBonus: 'Выплатить агентские бонусы',
      confirmPayTitle: 'Подтверждение выплаты',
      confirmPayText: 'Выполнить «{action}»? Действие необратимо.',
      payError: 'Ошибка выплаты',
      transferToRef: 'Перевести рефераленту',
      pool: 'Пул',
      referral: 'Реферал',
      agentBonus: 'Агентский бонус',
      recalc: 'Пересчитать',
      fixBonusPayout: 'Исправить выплату бонуса'
    },
    coreProxy: {
      title: 'Core Proxy',
      flushCache: 'Очистить кэш',
      terminateAll: 'Завершить все подключения'
    },
    nav: {
      setupDevice: 'Настроить устройство'
    },
    email: {
      sendEmail: 'Отправить email',
      verifying: 'Проверка...',
      to: 'Кому',
      subject: 'Тема',
      text: 'Текст',
      send: 'Отправить',
      sent: 'Письмо успешно отправлено'
    },
    poolStat: {
      hashPool: 'Хеш пула',
      hashBalancer: 'Хеш балансировщика',
      rewardPool: 'Награда пула',
      paid: 'Выплачено',
      refCalc: 'Реф. расчёт',
      refPaid: 'Реф. выплачено',
      ratePool: 'Ставка пула'
    },
    userWatcher: {
      list: 'Список',
      workers: 'Воркеры',
      transaction: 'Транзакция',
      newWatcher: 'Новый наблюдатель:',
      watcherTitle: 'Ссылки наблюдателей'
    },
    userStat: {
      emcd: 'EMCD',
      total: 'Итого'
    },
    incomeSub: {
      hash: 'Хеш',
      income: 'Доход',
      incomeFee: 'Комиссия дохода',
      referral: 'Реферал',
      referralFee: 'Реф. комиссия',
      forPay: 'К выплате',
      profit: 'Прибыль'
    },
    home: {
      title: 'Главная',
      users: 'Пользователи',
      activeUsers: 'Активные пользователи',
      onlyRegist: 'Только зарег.',
      deadUsers: 'Неактивные',
      activeMiners: 'Активные устройства',
      incomeBTC: 'Доход, BTC',
      allBalance: 'Общий баланс',
      bonusBTC: 'Бонус, BTC',
      bonusPercent: 'Бонус, %',
      noData: 'Нет данных',
      prev: 'НАЗАД',
      next: 'ДАЛЕЕ',
      tksAccount: 'Счёт',
      tksType: 'Тип',
      tksUnavailable: 'Недоступно (riskBinary не отвечает или не настроен)',
      tksCurrencyBalanceTitle: 'Баланс ТКС IMEX по валютам',
      tksCurrencyBalanceNote: 'Сопоставляет riskBinary Pos.PositionUpdate (balance_id) со справочником Instruments/Currency. Подтверждено живым ответом сервера 2026-09-02 (RUSBT001/002 вернули RUB и IMEX — собственный токен биржи, не USDT).',
      tksCurrencyCode: 'Валюта',
      tksCurrencyBalanceId: 'balance_id',
      tksCurrencyAmount: 'Сумма (clear_amount)',
      tksCurrencyUnknown: 'неизвестно (нет в справочнике)'
    },
    users: {
      role: 'Роль',
      vipMain: 'VIP осн. бонус',
      vipRef: 'VIP реф. бонус',
      blocked: 'Заблокирован',
      editTitle: 'Редактировать пользователя',
      createTitle: 'Создать пользователя',
      addUser: 'Добавить пользователя',
      emailVerified: 'Email подтверждён',
      wallet: 'Кошелёк',
      phone: 'Телефон',
      minerPass: 'Пароль майнера',
      switchPool: 'Переключить пользователя на пул:',
      switchBtn: 'Переключить',
      clearRecalc: 'Очистить и пересчитать',
      recalc10d: 'Пересчитать за 10 дней'
    },
    auth: {
      title: 'Вход',
      password: 'Пароль',
      minChars: 'Не меньше 3 символов',
      error: 'Ошибка авторизации',
      errorEmailNotVerified: 'Email не подтверждён. Подтвердите почту, чтобы войти.',
      goToVerify: 'Подтвердить email',
      restore: 'Восстановить',
      restoreTitle: 'Восстановление пароля',
      confirmEmail: 'Подтвердить почту',
      resendCode: 'Выслать код повторно',
      signIn: 'Войти',
      required: 'Обязательное поле!',
      repeatPassword: 'Повторить пароль',
      min4: 'Не меньше 4 символов',
      min8: 'Не меньше 8 символов',
      passwordMismatch: 'Пароли не совпадают',
      invalidEmail: 'Некорректная почта'
    },
    report: {
      title: 'Отчёты',
      reportFor: 'Отчет за'
    },
    hashrate: {
      '10min': 'Хешрейт за 10 мин',
      '1hour': 'Хешрейт за 1 час',
      '24hour': 'Хешрейт за 24 часа',
      shares: 'Шеры:',
      legend: '(принято / отклонено (%) / всего)'
    },
    setupMiner: {
      title: 'Настройка конфигурации стратума',
      workerConfig: 'Конфигурация воркера',
      workerHint: 'Для идентификации и получения статистики по каждому устройству задайте уникальные имена воркеров для каждого рига.',
      passwordHint: 'Если в настройках задать пароль для майнеров, то в конфигурации майнера необходимо прописывать этот пароль.'
    },
    minerCard: {
      number: 'Номер:',
      active: 'Активный:',
      model: 'Модель:',
      owner: 'Владелец:'
    },
    minerStatus: {
      info: 'Информация',
      model: 'Модель:',
      algorithm: 'Алгоритм:',
      website: 'Сайт:'
    },
    pivot: {
      avgHash: 'Средний хешрейт за сутки, Тh/s',
      power: 'Потребление, кВт',
      powerCost: 'Расход ээ, руб',
      poolPayout: 'Выплата на пул, ВТС',
      service: 'Обслуживание {service} BTC ({percent}%). Чистая прибыль {profit} BTC',
      total: 'Всего:'
    }
  }
}
